<template>
  <div class="ctx">

    <!-- ═══ Tabs ═══ -->
    <div class="ctx__tabs">
      <button class="ctx__tab" :class="{ 'ctx__tab--active': tipoVistaFacturas }" @click="tipoVistaFacturas = true">
        <i class="fa-solid fa-file-invoice-dollar"></i> Facturas
      </button>
      <button class="ctx__tab" :class="{ 'ctx__tab--active': !tipoVistaFacturas }" @click="tipoVistaFacturas = false">
        <i class="fa-solid fa-boxes-stacked"></i> Inventario
      </button>
    </div>

    <!-- ═══ Vista Facturas ═══ -->
    <template v-if="tipoVistaFacturas">
      <div class="ctx__section">
        <div class="ctx__header-row">
          <div class="ctx__summary">
            <span class="ctx__summary-label">Outstanding suppliers Dic-Nov ({{ anyoSelect }}):</span>
            <span class="ctx__summary-value ctx__summary-value--libra">{{ totalPendienteLibra }} &pound;</span>
            <span class="ctx__summary-sep">|</span>
            <span class="ctx__summary-value ctx__summary-value--euro">{{ totalPendienteEuro }} &euro;</span>
          </div>
          <div class="ctx__controls">
            <div class="ctx__control-item">
              <label class="ctx__filter-label">Año</label>
              <v-select v-model="anyoSelect" :options="anyoOptions" :clearable="false" class="ctx__control-select" />
            </div>
            <div class="ctx__control-item">
              <label class="ctx__filter-label">Libra</label>
              <b-form-input placeholder="" v-model="libra" class="ctx__control-input" />
            </div>
            <button class="ctx__btn ctx__btn--outline" @click="downloadPendiente" v-b-tooltip.hover title="Descargar listado">
              <i class="fa-solid fa-download"></i> Descargar
            </button>
          </div>
        </div>

        <!-- Facturas -->
        <div class="ctx__subsection">
          <h4 class="ctx__subsection-title">
            <i class="fa-solid fa-file-invoice ctx__subsection-icon ctx__subsection-icon--primary"></i>
            Facturas
          </h4>
          <div class="ctx__table-card">
            <div class="ctx__tabla-scroll">
              <b-table :items="facturasPendientes" :fields="columnasFacturas" class="ctx__table" no-border-collapse ref="table" hover />
            </div>
          </div>
        </div>

        <!-- Gastos -->
        <div class="ctx__subsection">
          <h4 class="ctx__subsection-title">
            <i class="fa-solid fa-receipt ctx__subsection-icon ctx__subsection-icon--warning"></i>
            Gastos
          </h4>
          <div class="ctx__table-card">
            <div class="ctx__tabla-scroll">
              <b-table :items="gastosPendientes" :fields="columnasGastos" class="ctx__table" no-border-collapse ref="table" hover />
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- ═══ Vista Inventario ═══ -->
    <template v-else>
      <div class="ctx__section">
        <div class="ctx__header-row">
          <div class="ctx__summary">
            <span class="ctx__summary-label">Valor inventario:</span>
            <span class="ctx__summary-value ctx__summary-value--libra">{{ totalValorInventarioLibra }} &pound;</span>
            <span class="ctx__summary-sep">|</span>
            <span class="ctx__summary-value ctx__summary-value--euro">{{ totalValorInventarioEuro }} &euro;</span>
            <span class="ctx__summary-sep">|</span>
            <span class="ctx__summary-label">Harber:</span>
            <span class="ctx__summary-value ctx__summary-value--euro">{{ totalValorHarberEuro }} &euro;</span>
            <span class="ctx__summary-sep">|</span>
            <span class="ctx__summary-label">CraftLab:</span>
            <span class="ctx__summary-value ctx__summary-value--euro">{{ totalValorCraftlabEuro }} &euro;</span>
          </div>
          <div class="ctx__controls">
            <div class="ctx__control-item">
              <label class="ctx__filter-label">Libra</label>
              <b-form-input placeholder="" v-model="libraInventario" class="ctx__control-input" />
            </div>
            <div class="ctx__control-item">
              <label class="ctx__filter-label">Noviembre de</label>
              <v-select v-model="anyoSelectInventario" :options="anyoOptions" :clearable="false" class="ctx__control-select" />
            </div>
            <button class="ctx__btn ctx__btn--outline" @click="downloadInventario" v-b-tooltip.hover title="Descargar listado">
              <i class="fa-solid fa-download"></i> Descargar
            </button>
          </div>
        </div>

        <!-- Inventario Sin Precio -->
        <div class="ctx__subsection">
          <h4 class="ctx__subsection-title">
            <i class="fa-solid fa-triangle-exclamation ctx__subsection-icon ctx__subsection-icon--danger"></i>
            Inventario Sin Precio
          </h4>
          <div class="ctx__table-card">
            <div class="ctx__tabla-scroll">
              <b-table :items="listaStock.filter((item) => item.price === 0)" :fields="columnasArticulos" class="ctx__table" no-border-collapse ref="table" hover />
            </div>
          </div>
        </div>

        <!-- Inventario -->
        <div class="ctx__subsection">
          <h4 class="ctx__subsection-title">
            <i class="fa-solid fa-boxes-stacked ctx__subsection-icon ctx__subsection-icon--success"></i>
            Inventario
          </h4>
          <div class="ctx__table-card">
            <div class="ctx__tabla-scroll">
              <b-table :items="listaStock.filter((item) => item.price != 0)" :fields="columnasArticulos" class="ctx__table" no-border-collapse ref="table" hover />
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- Modal descarga inventario -->
    <b-modal id="modal-descarga-inventario" title="Descargar inventario" centered hide-footer>
      <p class="ctx__descarga-texto">¿De qué empresa quieres el listado?</p>
      <div class="ctx__descarga-opciones">
        <button class="ctx__descarga-opcion" @click="generarCsvInventario('todo')">
          <span class="ctx__subsection-icon ctx__subsection-icon--primary"><i class="fa-solid fa-boxes-stacked"></i></span>
          <span class="ctx__descarga-opcion-info">
            <span class="ctx__descarga-opcion-nombre">Todo</span>
            <span class="ctx__descarga-opcion-desc">Listado completo con las columnas Harber y CraftLab</span>
          </span>
          <i class="fa-solid fa-download ctx__descarga-opcion-flecha"></i>
        </button>
        <button class="ctx__descarga-opcion" @click="generarCsvInventario('harber')">
          <span class="ctx__subsection-icon ctx__subsection-icon--success"><i class="fa-solid fa-building"></i></span>
          <span class="ctx__descarga-opcion-info">
            <span class="ctx__descarga-opcion-nombre">Harber</span>
            <span class="ctx__descarga-opcion-desc">Solo las unidades propiedad de Harber London</span>
          </span>
          <i class="fa-solid fa-download ctx__descarga-opcion-flecha"></i>
        </button>
        <button class="ctx__descarga-opcion" @click="generarCsvInventario('craftlab')">
          <span class="ctx__subsection-icon ctx__subsection-icon--warning"><i class="fa-solid fa-industry"></i></span>
          <span class="ctx__descarga-opcion-info">
            <span class="ctx__descarga-opcion-nombre">CraftLab</span>
            <span class="ctx__descarga-opcion-desc">Solo las unidades pendientes de facturar de Craft Lab</span>
          </span>
          <i class="fa-solid fa-download ctx__descarga-opcion-flecha"></i>
        </button>
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
import axios from "@axios";
import vSelect from "vue-select";
// import BCardCode from "@core/components/b-card-code";
import { BRow, BCol, BFormFile, BButton, BTable, BFormInput } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BRow,
    BCol,
    BFormFile,
    BButton,
    BFormInput,
    vSelect,
    BTable,
    flatPickr,
  },

  data() {
    return {
      csvInput: [],
      columnasFacturas: [
        {
          key: "codigo",
          label: "Codigo",
          sortable: true,
        },
        {
          key: "fecha",
          label: "Fecha",
          sortable: true,
        },
        {
          key: "fechaPagado",
          label: "Pagado",
          sortable: true,
        },
        {
          key: "categoria",
          label: "Categoria",
          sortable: true,
        },
        {
          key: "nombreEmpresa",
          label: "Empresa",
          sortable: true,
        },
        {
          key: "cliente",
          label: "Cliente",
          sortable: true,
        },
        {
          key: "ivatotal",
          label: "Iva",
          sortable: true,
        },
        {
          key: "total",
          label: "Total Є",
          sortable: true,
        },
      ],
      columnasGastos: [
        {
          key: "nombreEmpresa",
          label: "Empresa",
          sortable: true,
        },
        {
          key: "proveedor",
          label: "Proveedor",
          sortable: true,
        },
        {
          key: "codigo",
          label: "Codigo",
          sortable: true,
        },

        {
          key: "fechaFactura",
          label: "Fecha",
          sortable: true,
        },
        {
          key: "fechaPagado",
          label: "Pagado",
          sortable: true,
        },
        {
          key: "total",
          label: "Total Є",
          sortable: true,
        },
        {
          key: "notas",
          label: "Notas",
          sortable: true,
        },
      ],
      columnasArticulos: [
        {
          key: "sku",
          label: "Sku",
          sortable: true,
        },
        {
          key: "quantity",
          label: "Cantidad",
          sortable: true,
        },
        {
          key: "harber",
          label: "Harber",
          sortable: true,
        },
        {
          key: "craftlab",
          label: "CraftLab",
          sortable: true,
        },
        {
          key: "price",
          label: "Precio",
          sortable: true,
        },
        {
          key: "total",
          label: "Total Є",
          sortable: true,
        },
      ],
      anyoSelect: "2024",
      anyoSelectInventario: "2024",
      buscarFactura: "",
      allFacturas: [],
      allGastos: [],
      facturasPendientes: [],
      gastosPendientes: [],
      totalPendienteLibra: 0,
      totalPendienteEuro: 0,
      listaStock: [],
      anyoOptions: [],
      libra: 0.84,
      libraInventario: 0.84,
      totalValorInventarioEuro: 0,
      totalValorInventarioLibra: 0,
      totalValorHarberEuro: 0,
      totalValorCraftlabEuro: 0,
      fechaInventario: null,
      productsActual: [],
      preciosSku: [],
      tipoVistaFacturas: true,
      skuRepeticiones: []
    };
  },
  methods: {
    obtenerCambioGBP(fecha) {
      // fetch sin cabeceras: el axios global añade Authorization y dispara un
      // preflight CORS que la API de frankfurter no acepta
      const path = fecha || "latest";
      return fetch(`https://api.frankfurter.dev/v1/${path}?base=EUR&symbols=GBP`)
        .then((res) => res.json())
        .then((data) => data.rates.GBP)
        .catch((error) => {
          console.error("Error obteniendo cambio EUR/GBP:", error);
          return null;
        });
    },
    loadItems() {
      axios.post("/uso", {seccion:"corporation-tax"});
      //Si esta en negativo restar dinero

      const isDecember = new Date().getMonth() === 11;
      const currentYear = new Date().getFullYear();

      Promise.all([
        axios.get("/finanzas/facturas"),
        axios.get("/finanzas/gastos"),
      ])
        .then(([facturasResponse, gastosResponse]) => {
          this.allFacturas = facturasResponse.data;
          this.allGastos = gastosResponse.data;

          this.filtrarPorAnyo();
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });

      this.obtenerCambioGBP(isDecember ? `${currentYear}-11-30` : null)
        .then((rate) => {
          if (rate != null) {
            this.libra = rate;
            this.libraInventario = rate;
            this.filtrarPorAnyo();
          }
        });

      Promise.all([
        axios.get("/shopify/products"),
        axios.get("/finanzas/articulos"),
      ])
        .then(([productsResponse, preciosSkuResponse]) => {
          this.productsActual = productsResponse.data;
          this.preciosSku = preciosSkuResponse.data;
        
          this.skuRepeticiones = this.productsActual.flatMap(product => product.variants)
            .reduce((acc, variant) => {
              acc[variant.sku] = (acc[variant.sku] || 0) + 1;
              return acc;
            }, {});

          //this.filtrarInventario();
          this.filtrarInventarioNoviembre();
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    filtrarPorAnyo() {
      this.facturasPendientes = [];
      this.gastosPendientes = [];
      let totalEuro = 0;

      function checkFechaPagado(fecha, anyo) {
        if (!fecha) return true;

        const [year, month] = fecha.split("-").map(Number);

        if (year > anyo) return true;
        if (year === anyo) return month == 12;

        return false;
      }

      this.allFacturas.forEach((element) => {
        const [year, month] = element.fecha.split("-");

        if (
          ((year == this.anyoSelect-1 && Number(month) == 12) ||
          (year == this.anyoSelect && Number(month) <= 11)) &&
          checkFechaPagado(element.fechaPagado, this.anyoSelect) &&
          element.idCliente == 6
        ) {
          totalEuro += parseFloat(element.total) || 0;
          this.facturasPendientes.push(element);
        }
      });

      this.allGastos.forEach((element) => {
        const [year, month] = element.fechaFactura.split("-");

        if ( element.nombreEmpresa == "Harber London" && 
          ((year == this.anyoSelect-1 && Number(month) == 12) ||
          (year == this.anyoSelect && Number(month) <= 11))
          && checkFechaPagado(element.fechaPagado, this.anyoSelect)
        ) {
          if (element.pendiente == "") totalEuro += parseFloat(element.total) || 0;
          else
            totalEuro += parseFloat(element.total - element.pendiente) || 0;
          this.gastosPendientes.push(element);
        }
      });

      this.totalPendienteLibra = (totalEuro * this.libra).toFixed(2);
      this.totalPendienteEuro = totalEuro.toFixed(2);
    },
    filtrarInventariasfdo() {
      this.totalValorInventarioEuro = 0;

      const skuExcluidos = [
        "COURIER-FEE",
        "DEBOSS-CUSTOMIZATION",
        "E-GIFT-CARD",
        "E-GIFT-CARD-50",
        "E-GIFT-CARD-100",
        "E-GIFT-CARD-150",
        "E-GIFT-CARD-200",
        "E-GIFT-CARD-250",
        "E-GIFT-CARD-300",
        "E-GIFT-CARD-400",
        "EXTRA-PIECE",
        "GIFT-PACKAGING",
        "LEATHER-CUSTOMIZATION",
        "LOGO-DEBOSSED",
      ];

      const seenSkus = new Set();
      const fechaInventario = new Date(this.fechaInventario);
      const fechaActual = new Date();

      const mismoMesYAnio =
        fechaInventario.getFullYear() === fechaActual.getFullYear() &&
        fechaInventario.getMonth() === fechaActual.getMonth();

      //V - Si existe en confeccion y ubrique coger el precio mas bajo
      //V - Revisar valor libra
      //V - En inventario cuando se cambie la echa obtener el valor
      //Diciembre a Noviembre
      //Factura Gastos solo la de Empresa-Harber London


      const calcularPrecio = (sku) => {
        let precioReturn = 0;

        const precioData = sku
          ? this.preciosSku.find((precio) => sku.includes(precio.sku))
          : {};
        if (precioData.confeccion > 0 && precioData.ubrique > 0) {
          if (precioData.confeccion < precioData.ubrique)
            precioReturn = precioData.confeccion;
          else precioReturn = precioData.ubrique;

        } else if (precioData.confeccion > 0)
          precioReturn = precioData.confeccion;
        else if (precioData.ubrique > 0) precioReturn = precioData.ubrique;

        return precioReturn;

        return precioData
          ? precioData.confeccion || precioData.ubrique || 0
          : 0;
      };

      const procesarVariantes = (variantes) => {
        return variantes
          .filter((variant) => {
            const esExcluido =
              seenSkus.has(variant.sku) || skuExcluidos.includes(variant.sku);
            const tieneCantidadValida = variant.inventory_quantity >= 1;
            if (!esExcluido && tieneCantidadValida) {
              seenSkus.add(variant.sku);
              return true;
            }
            return false;
          })
          .map((variant) => {
            const precio = calcularPrecio(variant.sku);
            this.totalValorInventarioEuro +=
              variant.inventory_quantity * precio;

            return {
              sku: variant.sku,
              price: precio,
              total: (variant.inventory_quantity * precio).toFixed(2),
              quantity: variant.inventory_quantity,
            };
          });
      };

      let skuPriceArray = [];

      if (mismoMesYAnio || this.fechaInventario == null) {
        skuPriceArray = procesarVariantes(
          this.productsActual.flatMap((product) => product.variants)
        );
      } else {
        const month = String(fechaInventario.getMonth() + 1).padStart(2, "0");

        axios
          .post("/articulos/stock/fecha", {
            year: fechaInventario.getFullYear(),
            month,
          })
          .then((response) => response.data)
          .then((res) => {
            skuPriceArray = procesarVariantes(res);
          });
      }

      this.listaStock = skuPriceArray;

      this.totalValorInventarioLibra = (
        this.totalValorInventarioEuro * this.libraInventario
      ).toFixed(2);
      this.totalValorInventarioEuro = this.totalValorInventarioEuro.toFixed(2);
    },
    filtrarInventario() {
      this.totalValorInventarioEuro = 0;

      let skuExcluidos = [
        "COURIER-FEE",
        "DEBOSS-CUSTOMIZATION",
        "E-GIFT-CARD",
        "E-GIFT-CARD-50",
        "E-GIFT-CARD-100",
        "E-GIFT-CARD-150",
        "E-GIFT-CARD-200",
        "E-GIFT-CARD-250",
        "E-GIFT-CARD-300",
        "E-GIFT-CARD-400",
        "EXTRA-PIECE",
        "GIFT-PACKAGING",
        "LEATHER-CUSTOMIZATION",
        "LOGO-DEBOSSED",
      ];

      const seenSkus = new Set();

      const fechaInventario = new Date(this.fechaInventario);
      const fechaActual = new Date();

      const mismoMesYAnio = fechaInventario.getFullYear() === fechaActual.getFullYear() && fechaInventario.getMonth() === fechaActual.getMonth();

      let products = [];
      let skuPriceArray = [];

      if ( mismoMesYAnio || this.fechaInventario == null || this.fechaInventario == "") {
        products = this.productsActual;

        skuPriceArray = products.flatMap((product) =>
          product.variants
            .filter((variant) => {
              if ( seenSkus.has(variant.sku) || skuExcluidos.includes(variant.sku)) {
                return false;
              }
              /*if (variant.inventory_quantity < 1) {
                return false;
              }*/
              seenSkus.add(variant.sku);

              return true;
            })
            .map((variant) => {
              let precio = 0;

              if (variant.sku) {
                const sku = variant.sku;
                const precioData = sku ? this.preciosSku.find((precio) => sku.includes(precio.sku)) : {};

                precio = (precioData && precioData.confeccion > 0 && precioData.ubrique > 0)
                  ? Math.min(precioData.confeccion, precioData.ubrique)
                  : (precioData && precioData.confeccion > 0)
                  ? precioData.confeccion
                  : (precioData && precioData.ubrique > 0)
                  ? precioData.ubrique
                  : 0;
              
              }              

              this.totalValorInventarioEuro += variant.inventory_quantity * precio;

              return {
                sku: variant.sku,
                price: precio,
                total: (variant.inventory_quantity* precio).toFixed(2),
                quantity: variant.inventory_quantity,
              };
            })
        );

        this.listaStock = skuPriceArray;

        this.totalValorInventarioLibra = this.totalValorInventarioEuro * this.libraInventario;

        this.totalValorInventarioLibra = this.totalValorInventarioLibra.toFixed(2);
        this.totalValorInventarioEuro = this.totalValorInventarioEuro.toFixed(2);
      } else {
        const month = String(fechaInventario.getMonth() + 1).padStart(2, "0");
        
        axios
          .post("/articulos/stock/fecha", {
            year: fechaInventario.getFullYear(),
            month,
          })
          .then((response) => {
            return response.data;
          })
          .then((res) => {            
            this.totalValorInventarioEuro = 0;
            //console.log(res);
            skuPriceArray = res
              .filter((variant) => {
                // Verifica si el SKU ha sido visto o está en la lista de excluidos
                if ( seenSkus.has(variant.sku) || skuExcluidos.includes(variant.sku)) {
                  return false;
                }

                seenSkus.add(variant.sku);
                return true;
              })
              .map((variant) => {
                let precio = 0;

                if (variant.sku) {
                  const sku = variant.sku;
                  const precioData = sku
                    ? this.preciosSku.find((precio) => sku.includes(precio.sku))
                    : {};
                  if (precioData) {
                    // precio = precioData.confeccion || precioData.ubrique || 0;
                    precio = (precioData && precioData.confeccion > 0 && precioData.ubrique > 0)
                      ? Math.min(precioData.confeccion, precioData.ubrique)
                      : (precioData && precioData.confeccion > 0)
                      ? precioData.confeccion
                      : (precioData && precioData.ubrique > 0)
                      ? precioData.ubrique
                      : 0;
                  }
                }

                const repeticiones = this.skuRepeticiones[variant.sku] || 1;
                let cantidadDividida = Math.floor(variant.cantidad / repeticiones); 

                this.totalValorInventarioEuro += cantidadDividida * precio;

                //92833.77 round
                //92309.15 floor
                //92931.26 ceil

                return {
                  sku: variant.sku,
                  price: precio,
                  total: (cantidadDividida * precio).toFixed(2),
                  quantity: cantidadDividida,
                };
              });

            this.listaStock = skuPriceArray;

            this.totalValorInventarioLibra = this.totalValorInventarioEuro * this.libraInventario;

            this.totalValorInventarioLibra = this.totalValorInventarioLibra.toFixed(2);
            this.totalValorInventarioEuro = this.totalValorInventarioEuro.toFixed(2);
          });
      }
    },
    filtrarInventarioNoviembre() {
      this.totalValorInventarioEuro = 0;

      let skuExcluidos = [
        "COURIER-FEE",
        "DEBOSS-CUSTOMIZATION",
        "E-GIFT-CARD",
        "E-GIFT-CARD-50",
        "E-GIFT-CARD-100",
        "E-GIFT-CARD-150",
        "E-GIFT-CARD-200",
        "E-GIFT-CARD-250",
        "E-GIFT-CARD-300",
        "E-GIFT-CARD-400",
        "EXTRA-PIECE",
        "GIFT-PACKAGING",
        "LEATHER-CUSTOMIZATION",
        "LOGO-DEBOSSED",
      ];

      const seenSkus = new Set();
      let skuPriceArray = [];

      const fechaCorte = `${this.anyoSelectInventario}-11-30`;

      Promise.all([
        axios.post("/articulos/stock/noviembre", {
          year: this.anyoSelectInventario,
        }),
        axios.post("/finanzas/stock/propietario", { fecha: fechaCorte })
          .catch((error) => {
            console.error("Error obteniendo propietario del stock:", error);
            return { data: { producido: [], facturado: [] } };
          }),
      ])
        .then(([stockResponse, propietarioResponse]) => {
          const res = stockResponse.data;

          // Pendiente de facturar por CraftLab a fecha de corte = producido - facturado
          const producidoMap = {};
          propietarioResponse.data.producido.forEach((p) => {
            producidoMap[p.sku] = parseFloat(p.producido) || 0;
          });
          const facturadoMap = {};
          propietarioResponse.data.facturado.forEach((f) => {
            facturadoMap[f.sku] = parseFloat(f.facturado) || 0;
          });

          this.totalValorInventarioEuro = 0;
          this.totalValorHarberEuro = 0;
          this.totalValorCraftlabEuro = 0;
          //console.log(res);

          skuPriceArray = res
            .filter((variant) => {
              // Verifica si el SKU ha sido visto o está en la lista de excluidos
              if ( seenSkus.has(variant.sku) || skuExcluidos.includes(variant.sku)) {
                return false;
              }

              if(variant.sku== "") return false;
              // Verifica si la cantidad es menor que 1
              /*if (variant.cantidad < 1) {
                return false;
              }*/
              seenSkus.add(variant.sku);
              return true;
            })
            .map((variant) => {
              let precio = 0;

              if (variant.sku) {
                const sku = variant.sku;
                const precioData = sku
                  ? this.preciosSku.find((precio) => sku.includes(precio.sku))
                  : {};
                if (precioData) {
                  // precio = precioData.confeccion || precioData.ubrique || 0;
                  precio = (precioData && precioData.confeccion > 0 && precioData.ubrique > 0)
                    ? Math.min(precioData.confeccion, precioData.ubrique)
                    : (precioData && precioData.confeccion > 0)
                    ? precioData.confeccion
                    : (precioData && precioData.ubrique > 0)
                    ? precioData.ubrique
                    : 0;
                }
              }

              /*const repeticiones = this.skuRepeticiones[variant.sku] || 1;
              let cantidadDividida = Math.floor(variant.cantidad / repeticiones); */

              this.totalValorInventarioEuro += variant.cantidad  * precio;

              //92833.77 round
              //92309.15 floor
              //92931.26 ceil

              // Reparto de propiedad: lo producido y aun no facturado a fecha
              // de corte es de CraftLab, el resto es de Harber (Ubrique incluido)
              const pendienteCraftlab = Math.max(0, (producidoMap[variant.sku] || 0) - (facturadoMap[variant.sku] || 0));
              const craftlab = Math.min(variant.cantidad, pendienteCraftlab);
              const harber = variant.cantidad - craftlab;

              this.totalValorHarberEuro += harber * precio;
              this.totalValorCraftlabEuro += craftlab * precio;

              return {
                sku: variant.sku,
                price: precio,
                total: (variant.cantidad * precio).toFixed(2),
                quantity: variant.cantidad ,
                harber: harber,
                craftlab: craftlab,
              };
            });

          this.listaStock = skuPriceArray;

          this.totalValorInventarioLibra = this.totalValorInventarioEuro * this.libraInventario;

          this.totalValorInventarioLibra = this.totalValorInventarioLibra.toFixed(2);
          this.totalValorInventarioEuro = this.totalValorInventarioEuro.toFixed(2);
          this.totalValorHarberEuro = this.totalValorHarberEuro.toFixed(2);
          this.totalValorCraftlabEuro = this.totalValorCraftlabEuro.toFixed(2);
        });

    },
    downloadPendiente() {
      var csv = "Codigo;Fecha;Pagado;Categoria;Empresa;Cliente;IVA;TOTAL Є\n";

      this.facturasPendientes.forEach((factura) => {
        csv +=
          factura.codigo +
          ";" +
          factura.fecha +
          ";" +
          factura.fechaPagado +
          ";" +
          factura.categoria +
          ";" +
          factura.nombreEmpresa +
          ";" +
          factura.cliente +
          ";" +
          factura.ivatotal +
          ";" +
          factura.total +
          "\n";
      });

      csv += "Empresa;Proveedor;Codigo;Fecha;Pagado;Total Є\n";

      this.gastosPendientes.forEach((factura) => {
        csv +=
          factura.nombreEmpresa +
          ";" +
          factura.proveedor +
          ";" +
          factura.codigo +
          ";" +
          factura.fechaFactura +
          ";" +
          factura.fechaPagado +
          ";" +
          factura.total +
          "\n";
      });

      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", "data:text/csv;charset=utf-8," + encodedUri);
      link.setAttribute("download", "Outstanding_suppliers.csv");
      document.body.appendChild(link);
      link.click();
    },
    downloadInventario() {
      this.$bvModal.show("modal-descarga-inventario");
    },
    generarCsvInventario(empresa) {
      this.$bvModal.hide("modal-descarga-inventario");

      var csv;
      var nombre;

      if (empresa === "todo") {
        csv = "SKU;Cantidad;Harber;CraftLab;Fabricacion;TOTAL Є\n";

        this.listaStock.forEach((articulo) => {
          csv +=
            articulo.sku +
            ";" +
            articulo.quantity +
            ";" +
            (articulo.harber != undefined ? articulo.harber : "") +
            ";" +
            (articulo.craftlab != undefined ? articulo.craftlab : "") +
            ";" +
            articulo.price +
            ";" +
            articulo.total +
            "\n";
        });

        nombre = "precio_inventario.csv";
      } else {
        csv = "SKU;Cantidad;Fabricacion;TOTAL Є\n";

        this.listaStock.forEach((articulo) => {
          const cantidad = (empresa === "harber" ? articulo.harber : articulo.craftlab) || 0;
          if (cantidad <= 0) return;

          csv +=
            articulo.sku +
            ";" +
            cantidad +
            ";" +
            articulo.price +
            ";" +
            (cantidad * articulo.price).toFixed(2) +
            "\n";
        });

        nombre = "precio_inventario_" + empresa + ".csv";
      }

      var encodedUri = encodeURI(csv);
      var link = document.createElement("a");
      link.setAttribute("href", "data:text/csv;charset=utf-8," + encodedUri);
      link.setAttribute("download", nombre);
      document.body.appendChild(link);
      link.click();
    },
  },
  mounted() {
    this.anyoOptions = [];
    const currentYear = new Date().getFullYear();

    for (let year = currentYear; year >= 2018; year--) {
      this.anyoOptions.push(year);
    }

    this.anyoSelect = currentYear;

    // Seleccionar por defecto el ultimo noviembre con datos reales de stock
    axios
      .get("/articulos/sku/stock/noviembre/last")
      .then((response) => {
        if (response.data && response.data.anyo)
          this.anyoSelectInventario = response.data.anyo;
      })
      .catch((error) => {
        console.error("Error obteniendo ultimo noviembre con stock:", error);
      });

    this.loadItems();
  },
  watch: {
    anyoSelect() {
      const selectedAnyo = this.anyoSelect;
      const currentYear = new Date().getFullYear();
      const isDecember = new Date().getMonth() === 11;

      let fecha = null;

      if (selectedAnyo !== currentYear)
        fecha = `${selectedAnyo}-11-30`;
      else if (isDecember)
        fecha = `${currentYear}-11-30`;

      this.obtenerCambioGBP(fecha)
        .then((rate) => {
          if (rate != null) this.libra = rate;
          this.filtrarPorAnyo();
        });
    },
    libra() {
      try {
        const euro = parseFloat(this.totalPendienteEuro) || 0;
        this.totalPendienteLibra = (euro * this.libra).toFixed(2);
        this.totalPendienteEuro = euro.toFixed(2);
      } catch (error) {}
    },
    libraInventario() {
      try {
        const euro = parseFloat(this.totalValorInventarioEuro) || 0;
        this.totalValorInventarioLibra = (euro * this.libraInventario).toFixed(2);
        this.totalValorInventarioEuro = euro.toFixed(2);
      } catch (error) {}
    },
    anyoSelectInventario(){

      let fecha = this.anyoSelectInventario != "" ? `${this.anyoSelectInventario}-11-30` : null;

      this.obtenerCambioGBP(fecha)
        .then((rate) => {
          if (rate != null) this.libraInventario = rate;
          this.filtrarInventarioNoviembre();
        });
    },
    fechaInventario() {
      let fecha = this.fechaInventario != "" ? this.fechaInventario : null;

      this.obtenerCambioGBP(fecha)
        .then((rate) => {
          if (rate != null) this.libraInventario = rate;
          this.filtrarInventario();
        });
    },
  },
};
</script>
  
  <style lang="scss">
@import "../@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

/* ═══ Tabla global styles ═══ */
.ctx__table {
  margin-bottom: 0;

  thead th {
    background: #f8f9fb !important;
    border-bottom: 2px solid #e9ecf1 !important;
    border-top: none !important;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #8a8e99;
    padding: 12px 14px;
    white-space: nowrap;
  }

  tbody td {
    padding: 10px 14px;
    vertical-align: middle;
    border-bottom: 1px solid #f0f1f4 !important;
    border-top: none !important;
    font-size: 13px;
    color: #5e5873;
    white-space: nowrap;
  }

  tbody tr {
    transition: background 0.15s;
    background: transparent !important;

    &:hover {
      background: #f9f8ff !important;
    }
  }
}

.dark-layout {
  .ctx__tabs {
    background: #242424 !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
  }

  .ctx__tab {
    color: #b4b7bd !important;
    &:hover { background: #2e2e2e !important; color: #d0d2d6 !important; }
  }
  .ctx__tab--active,
  .ctx__tab--active:hover { color: #fff !important; }

  .ctx__header-row {
    background: #242424 !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
  }

  .ctx__summary-label { color: #b4b7bd !important; }
  .ctx__summary-value { color: #d0d2d6 !important; }
  .ctx__filter-label { color: #b4b7bd !important; }

  .ctx__subsection {
    background: #242424 !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
  }

  .ctx__subsection-title { color: #d0d2d6 !important; }

  .ctx__table-card { border-color: #333 !important; }

  .ctx__table {
    thead th { background: #2e2e2e !important; border-bottom-color: #333 !important; color: #b4b7bd !important; }
    tbody td { color: #d0d2d6 !important; border-bottom-color: #333 !important; }
    tbody tr:hover { background: #2e2e2e !important; }
  }
}
</style>

<style scoped>
/* ═══ Layout ═══ */
.ctx {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ═══ Tabs ═══ */
.ctx__tabs {
  display: flex;
  gap: 6px;
  background: #fff;
  border-radius: 14px;
  padding: 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  width: fit-content;
}

.ctx__tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  background: transparent;
  color: #8a8e99;
}
.ctx__tab:hover {
  background: #f8f9fb;
  color: #5e5873;
}
.ctx__tab--active {
  background: linear-gradient(135deg, #7367f0 0%, #9b8cf8 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.35);
}
.ctx__tab--active:hover {
  background: linear-gradient(135deg, #7367f0 0%, #9b8cf8 100%);
  color: #fff;
}

/* ═══ Section ═══ */
.ctx__section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ═══ Header row ═══ */
.ctx__header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: #fff;
  border-radius: 14px;
  padding: 18px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}

.ctx__summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ctx__summary-label {
  font-size: 14px;
  font-weight: 600;
  color: #5e5873;
}

.ctx__summary-value {
  font-size: 19px;
  font-weight: 600;
  color: #3b4253;
}

.ctx__summary-value--libra {
  color: #7367f0;
}

.ctx__summary-value--euro {
  color: #28c76f;
}

.ctx__summary-sep {
  color: #d0d2d6;
  font-size: 18px;
}

.ctx__controls {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
}

.ctx__control-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ctx__filter-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8a8e99;
  margin-bottom: 0;
}

.ctx__control-select {
  min-width: 110px;
}

.ctx__control-input {
  width: 110px;
}

/* ═══ Botones ═══ */
.ctx__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.ctx__btn--outline {
  background: transparent;
  color: #7367f0;
  border: 1px solid #7367f0;
}
.ctx__btn--outline:hover {
  background: #7367f0;
  color: #fff;
}

/* ═══ Subsections ═══ */
.ctx__subsection {
  background: #fff;
  border-radius: 14px;
  padding: 20px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.ctx__subsection-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #3b4253;
  margin-bottom: 14px;
}

.ctx__subsection-icon {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  flex-shrink: 0;
}
.ctx__subsection-icon--primary { background: #eeedfd; color: #7367f0; }
.ctx__subsection-icon--warning { background: #fff3e0; color: #ff9f43; }
.ctx__subsection-icon--danger  { background: #fce4e4; color: #ea5455; }
.ctx__subsection-icon--success { background: #e8fce8; color: #28c76f; }

/* ═══ Modal descarga inventario ═══ */
.ctx__descarga-texto {
  font-size: 13px;
  color: #8a8e99;
  margin-bottom: 14px;
}

.ctx__descarga-opciones {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 6px;
}

.ctx__descarga-opcion {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #f0f1f4;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition: all 0.2s;
}

.ctx__descarga-opcion:hover {
  border-color: #7367f0;
  box-shadow: 0 2px 10px rgba(115, 103, 240, 0.15);
}

.ctx__descarga-opcion-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
}

.ctx__descarga-opcion-nombre {
  font-size: 14px;
  font-weight: 600;
  color: #3b4253;
}

.ctx__descarga-opcion-desc {
  font-size: 12px;
  color: #8a8e99;
}

.ctx__descarga-opcion-flecha {
  color: #d0d2d6;
  font-size: 13px;
  transition: color 0.2s;
}

.ctx__descarga-opcion:hover .ctx__descarga-opcion-flecha {
  color: #7367f0;
}

/* ═══ Tabla card ═══ */
.ctx__table-card {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #f0f1f4;
}

.ctx__tabla-scroll {
  width: 100%;
  overflow-x: auto;
}
</style>